<template>
  <footer>
    <div class="container_w clear">
      <ul class="footer_top clear">
        <li class="left">
          <div>Follow Us</div>
          <div class="fb_icon"></div>
        </li>
        <li class="right">
          <div>CSC Sales and Service Hotline:</div>
          <div class="tel_icon">+86 28 8888 8888(7x24h)</div>
        </li>
      </ul>
      <div class="footer_nav clear">
        <ul class="left" v-for="(item,index) in footerList" :key="index">
          <li>{{ item.nodeTitle }}</li>
          <li v-for="(list,i) in item.childrens" :key="i"
              v-show="list.officeIdStr?list.officeIdStr.indexOf(OfficeID) >-1?true:false:true">
            <!--          <li v-for="(list,i) in item.childrens" :key="i">-->
            <router-link
                :to="{path:'/interlayer',query: {list: list}}">
              {{ list.title }}
            </router-link>
          </li>
        </ul>
        <!-- <ul class="left">
            <li>Support</li>
            <li><router-link to="/sitemap">Site Map</router-link></li>
        </ul>
        <ul class="left">
            <li>Member</li>
            <li>Log In</li>
        </ul>
        <ul class="left">
            <li>Policy</li>
            <li>Cookie Policy</li>
            <li>Privacy Policy</li>
        </ul> -->
      </div>
      <div class="footer_bottom">Copyright Sichuan Airlines. All Rights Reserved. <span @click="goIcp"
                                                                                        style="cursor: pointer;">蜀ICP备18038377-1</span>
      </div>
    </div>

    <div class="cookie_box" v-if="showCookiePop">
      <div style="float: right;position: relative;top: -32px;margin-right: 10px;margin-top: 5px;"><img
          src="/M/assets/dist/images/icon_close_t.png" width="24" @click="continueCookie"></div>
      <div class="container_w clear">

        <p class="left">This website uses Cookies for analytics, personalisation and advertising. Click <span
            @click="goUrlPage('0')">Cookie Statement</span> to learn how to manage your cookie settings.
            <span @click="goUrlPage('1')">Privacy Policy</span> </p>
          <p class="left" @click="cookieSetting('ALLOW ALL')" style="width: auto;cursor:pointer">【ALLOW ALL】</p>
          <p class="left" @click="cookieSetting('REJECT ALL')" style="width: auto;cursor:pointer">【REJECT ALL】</p>
          <p class="left" @click="cookieSetting('Cookie Settings')" style="width: auto;cursor:pointer">【Cookie Settings】</p>
        <!-- <input class="right" style="margin-left:20px" type="button" value="Cookie Statement"  @click="goUrlPage('0')">
        <input class="right" type="button" value="Continue" @click="continueCookie"> -->
      </div>
    </div>
      <Modal v-model="cookieSettingsVisible" title="Cookie Settings" @cancel="handleCancelCookieSettings">
          <template slot="footer">
              <Button key="back" @click="handleCancelCookieSettings">Cancel</Button>
              <Button key="submit" type="danger" @click="handleOkCookieSettings">OK</Button>
          </template>
          <div style="display: flex">
              <a-switch default-checked :checked="strictlyNecessaryCookies" disabled />
              <p><span style="margin-left: 5px;">Strictly necessary Cookies</span></p>
          </div>
          <div style="margin-top: 20px;">These Cookies are absolutely necessary in order to provide you with website services and use some of its functions, such as accessing safe areas. </div>
          <div style="display: flex; margin-top: 20px;">
              <a-switch v-model="analyticsCookies" />
              <p><span style="margin-left: 5px;">Analytics cookies</span></p>
          </div>
          <div style="margin-top: 20px;">These Cookies collect information to help us understand the usage of the website or the effectiveness of marketing activities in a summary form, or to help us customize the website for you. This information will also be used to evaluate your use of the website, prepare reports on website activities and receive other services related to website activities and Internet use. </div>
      </Modal>

  </footer>
</template>

<script>
import { Modal, Button } from "ant-design-vue";
export default {
  components: { Modal, Button },
  name: 'Footer',
  data() {
    return {
      OfficeID: '',
      footerList: [],
      showCookiePop: true,
        cookieSettingsVisible: false,
        strictlyNecessaryCookies: true,
        analyticsCookies: false,
    }
  },
  props: {},
  watch: {},
  methods: {
    goUrlPage(pId) {
      let arr = [...this.footerList]
      let newData = {}
      arr.forEach((item, index) => {
        if (item.nodeTitle === "Legal information") {
          item.childrens.forEach((item1) => {
            newData[item1.title] = item1
          })
        }
      })
        console.log(newData, '========newData======')
      if (pId == '0') {
        //   cookie
        console.log('3333333',newData)
        console.log('444444',newData['Cookies Statement'])
        // path:'/interlayer',query: {list: list}
        console.log('55555',JSON.stringify(newData['Cookies Statement']))
        this.$router.push({
          name: 'interlayer',
          query: {
            list: JSON.stringify(newData['Cookies Statement'])
          }
        })

      } else {
        console.log('8888')
        console.log(newData['Privacy Policy'])
        console.log(pId)
        this.$router.push({
          name: 'interlayer',
          query: {
            list: JSON.stringify(newData['Privacy Policy'])
          }
        })
      }
    },
    continueCookie() {
      this.$Utils.setLocal('COOKIE_STATE', 'isHide')
      this.showCookiePop = false
    },
    goIcp() {
      window.location.href = 'http://beian.miit.gov.cn/'
    },
    cookieSetting(code) {
        console.log(code)
      if (code === "ALLOW ALL") {
          this.analyticsCookies = true
      }
      if (code === "REJECT ALL") {
          this.analyticsCookies = false
      }
      if (code === "Cookie Settings") {
          this.analyticsCookies = false
      }
      this.cookieSettingsVisible = true
    },
      handleCancelCookieSettings() {
          this.analyticsCookies = false
          this.cookieSettingsVisible = false
      },
      handleOkCookieSettings() {
          if (this.analyticsCookies) {
              this.$Utils.setLocal('COOKIE_STATE', '1')
          } else {
              this.$Utils.setLocal('COOKIE_STATE', '00')
          }
          this.cookieSettingsVisible = false
          this.showCookiePop = false
      }
  },
  filters: {},
  computed: {},
  created() {
    let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    this.OfficeID = OfficeID //
    // this.OfficeID = 'LAX3U12TK' //
    this.footerList = FOOTERJSON[0].childrens
    console.log('OfficeID', this.footerList)

    let cookieState = this.$Utils.getLocal('COOKIE_STATE') || ''
    if (cookieState) {
      this.showCookiePop = false
    }
  },
  mounted() {

  },
  destroyed() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
footer {
  background: rgba(72, 77, 83, 1);
  box-shadow: 0px 1px 0px 0px rgba(218, 223, 227, 0.5);

  .footer_top {
    font-size: 18px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 21px;
    margin-bottom: 32px;

    li {
      &:first-child {
        margin-top: 30px;

        .fb_icon {
          width: 32px;
          height: 32px;
          background: url(../../assets/footer/icon_foot_facebook.png) no-repeat center;
          background-size: 100% 100%;
          margin-top: 25px;
        }
      }

      &:last-child {
        margin-top: 26px;

        .tel_icon {
          margin-top: 24px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;

          &::before {
            content: '';
            margin-right: 8px;
            float: left;
            width: 16px;
            height: 16px;
            background: url(../../assets/footer/icon_foot_cellphone.png) no-repeat center;
          }
        }
      }
    }
  }

  .footer_nav {
    margin-bottom: 64px;

    ul {
      width: 288px;

      &:last-child {
        width: auto;
      }

      li {
        &:first-child {
          font-size: 18px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 21px;
          margin-bottom: 24px;
        }

        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        a {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
        }
      }
    }
  }

  .footer_bottom {
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 14px;
    border-top: 1px solid rgba(236, 238, 240, .1);
    height: 65px;
    line-height: 65px;

    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 17px;
      margin-left: 16px;
    }
  }
}

.cookie_box {
  padding: 32px 0;
  background-color: #FFBB18;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  p {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 16px;
    width: 1120px;

    span {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  input {
    width: 160px;
    height: 40px;
    font-size: 16px;
    color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 1);
    display: inline-block;
    background-color: #FFBB18;
    cursor: pointer;
  }
}
</style>
